import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CapacitaSegModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black z-40"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-x-4 top-[10%] md:inset-x-auto md:left-1/2 md:-translate-x-1/2 md:max-w-2xl bg-white rounded-2xl shadow-2xl z-50 overflow-y-auto max-h-[80vh] my-4"
          >
            <div className="relative p-6 md:p-8">
              {/* Botão Fechar */}
              <button
                onClick={onClose}
                className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Cabeçalho */}
              <div className="text-center mb-8">
                <p className="text-emerald-500 font-medium mb-4">CERTIFICAÇÃO COM VALIDADE NACIONAL</p>
                <img
                  src="/logos/capacitaseg-color.png"
                  alt="CapacitaSeg Logo"
                  className="h-12 mx-auto mb-6"
                />
                <h2 className="text-3xl font-bold text-teal-900 mb-4">
                  Os melhores cursos de Segurança do Trabalho para sua carreira e empresa
                </h2>
                <p className="text-gray-600 text-lg">
                  Capacitação profissional em normas regulamentadoras com certificados válidos em todo o território nacional. Estude online e avance na sua carreira.
                </p>
              </div>

              {/* Estatísticas */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-8">
                <div className="flex items-center justify-center gap-3">
                  <div className="bg-emerald-100 rounded-full p-3">
                    <svg className="w-6 h-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="text-center">
                    <p className="text-2xl font-bold text-emerald-600">+5.000</p>
                    <p className="text-sm text-gray-600">profissionais capacitados em todo Brasil</p>
                  </div>
                </div>
              </div>

              {/* Lista de Benefícios */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-emerald-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <p className="text-gray-700">Certificado digital na hora - mesmo valor legal do presencial</p>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-emerald-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <p className="text-gray-700">Professores especialistas - engenheiros e técnicos certificados</p>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-emerald-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <p className="text-gray-700">Plataforma intuitiva - acesse de qualquer dispositivo</p>
                </div>
              </div>

              {/* Botões de Ação */}
              <div className="flex justify-center">
                <a
                  href="https://capacitaseg.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-emerald-600 hover:bg-emerald-700 text-white text-center font-semibold py-3 px-12 rounded-lg transition-colors"
                >
                  Conheça agora
                </a>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CapacitaSegModal;